import axios from '@/axios-api';
import Pathes from '@/helpers/pathes';
import { getQuery } from '@/helpers/utils';

export const streakService = {
  status: () => axios.get(Pathes.Streak.status),
  milestoneRewards: () => axios.get(Pathes.Streak.rewards),
  leaderboards: params =>
    axios.get(Pathes.Streak.leaderboards + getQuery(params)),
  activity: params => axios.get(Pathes.Streak.activity + getQuery(params)),
};
